import { insert as d, effect as n, className as o, setAttribute as i, template as c } from "solid-js/web";
import { cn as m } from "../../utils/class.js";
var p = c("<div data-type=date-picker-calendar-row data-scope=date-picker role=row>");
const l = (e) => {
  return a = p(), d(a, () => e.children), n((r) => {
    var s = m(`
          rn-grid
          rn-grid-cols-7
          rn-text-sm
        `, { "date-picker-week-names-row rn-my-2": e.header, "date-picker-days-row rn-mb-[0.13rem]": !e.header }, e.weekNamesRowClass, e.daysRowClass), t = e.header ? "header" : "row";
    return s !== r.e && o(a, r.e = s), t !== r.t && i(a, "data-part", r.t = t), r;
  }, { e: void 0, t: void 0 }), a;
  var a;
};
export {
  l as DatePickerWeek
};
